module.exports = "<div class=\"row rail-results hidden-xs\"><div class=pull-right><div class=available-fares ng-click=\"showUkrailResults('roundtrip')\"><span class=i-rail-green></span> <span class=offer-text><l10n>Rail Fares Available From</l10n>&nbsp;{{::railMinTotal | currency: currencySign}}</span></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base/templates/flights/ukrail_results.tmpl.html
// module id = 695
// module chunks = 0